<template>
    <div v-if="showSidebar" class="TTL-cate-box">
        <span class="TTL-add-cate" @click="openDialog()">+ 添加分类</span>
        <div class="TTL-cate-content">
            <div class="cate-box">
                <div
                    class="cate-item"
                    v-for="(item, index) in renderCates"
                    :key="item.id !== '' && item.id !== null && item.id !== undefined ? `tc-${item.id}` : `tc-all-${index}`"
                >
                    <div class="cate-name-box">
                        <span
                            class="title title-with-caret"
                            :style="{ color: isCateRowActive(item) ? '#666eeb' : '#333' }"
                            @click.stop="handleSelectCate(item)"
                        >
                            <i class="cate-title-caret" aria-hidden="true" />
                            <span class="cate-title-text">{{ item.name }}</span>
                        </span>
                        <div class="icon-box" v-if="item.id > 0">
                            <div class="icon edit" @click.stop="openDialog(item)" />
                            <div class="icon del" @click.stop="handleDeleteCate(item)" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <el-dialog
        v-model="dialogVisible"
        :title="form.id ? '编辑分类' : '新增分类'"
        width="420px"
        :close-on-click-modal="false"
        append-to-body
    >
        <div class="add-tutarial-cate-form">
            <div class="form-item">
                <div class="form-label">分类名称</div>
                <div class="form-control">
                    <wcinput
                        :value="form.name"
                        :option="{
                            placeholder: '请输入分类名称',
                            type: 'input',
                            clearable: true,
                            width: '250px',
                            ischange: true,
                        }"
                        @finish="(val) => { form.name = val && val.value !== undefined ? val.value : ''; }"
                    />
                </div>
            </div>
            <div class="form-item">
                <div class="form-label">排序</div>
                <div class="form-control">
                    <wcinput
                        :value="form.sort"
                        :option="{
                            placeholder: '请输入排序值',
                            type: 'input',
                            clearable: true,
                            width: '250px',
                            ischange: true,
                        }"
                        @finish="(val) => { form.sort = val && val.value !== undefined ? val.value : ''; }"
                    />
                </div>
            </div>
        </div>
        <template #footer>
            <div class="dialog-footer">
                <wcbutton :option="{ title: '取消', type: 'del' }" @finish="dialogVisible = false" />
                <wcbutton :option="{ title: '提交' }" @finish="submitForm" />
            </div>
        </template>
    </el-dialog>
</template>

<script>
import INTERFACE_MODEL_TUTARIAL from '@/Interface/Es/Tutarial';

export default {
    name: 'TutarialCategoryPanel',
    props: {
        selectedId: {
            type: [Number, String],
            default: '',
        },
        variant: {
            type: String,
            default: 'sidebar',
            validator: (v) => ['sidebar', 'dialogOnly'].includes(v),
        },
    },
    emits: ['select-category', 'categories-updated'],
    data() {
        return {
            cateList: [],
            dialogVisible: false,
            submitLoading: false,
            form: {
                id: '',
                name: '',
                sort: 0,
            },
        };
    },
    computed: {
        showSidebar() {
            return this.variant === 'sidebar';
        },
        renderCates() {
            const list = Array.isArray(this.cateList) ? this.cateList : [];
            return [{ id: '', name: '全部' }, ...list];
        },
    },
    mounted() {
        this.loadCateList();
    },
    methods: {
        openDialog(item) {
            if (item && item.id) {
                this.form = {
                    id: item.id,
                    name: item.name || '',
                    sort: item.sort !== undefined && item.sort !== null && item.sort !== '' ? item.sort : 0,
                };
            } else {
                this.form = { id: '', name: '', sort: 0 };
            }
            this.dialogVisible = true;
        },
        reloadCategories() {
            return this.loadCateList();
        },
        async loadCateList() {
            try {
                const res = await INTERFACE_MODEL_TUTARIAL.GET_TUTARIAL_CATE_LIST({ p: 1, rollpage: 10000 });
                if (res && res.status > 0) {
                    this.cateList = [];
                    return;
                }
                this.cateList = res && res.data && Array.isArray(res.data.list) ? res.data.list : [];
            } catch (error) {
                console.error('获取教程分类错误：', error);
                this.$notice({ title: '错误', message: '获取教程分类失败', type: 'error' });
                this.cateList = [];
            }
        },
        refreshCateCache() {
            if (this.$method && this.$method.GET_TUTARIAL_CATES) {
                this.$method.GET_TUTARIAL_CATES(true);
            }
        },
        isCateRowActive(item) {
            const sel = this.selectedId;
            const id = item && item.id;
            const noSel = sel === '' || sel === null || sel === undefined;
            if (noSel) {
                return id === '' || id === null || id === undefined;
            }
            return String(id) === String(sel);
        },
        handleSelectCate(item) {
            const raw = item && item.id;
            const normalized = raw === '' || raw === null || raw === undefined ? '' : raw;
            this.$emit('select-category', { categoryId: normalized });
        },
        async submitForm() {
            if (this.submitLoading) return;
            const name = String(this.form.name || '').trim();
            if (!name) {
                this.$notice({ title: '提示', message: '请输入分类名称', type: 'warning' });
                return;
            }
            if (this.form.sort === '' || this.form.sort === null) {
                this.$notice({ title: '提示', message: '请输入排序', type: 'warning' });
                return;
            }
            const sortNum = Number(this.form.sort);
            if (Number.isNaN(sortNum)) {
                this.$notice({ title: '提示', message: '排序必须为数字', type: 'warning' });
                return;
            }
            const payload = { name, sort: sortNum };
            try {
                this.submitLoading = true;
                if (!this.form.id) {
                    const res = await INTERFACE_MODEL_TUTARIAL.ADD_TUTARIAL_CATE({
                        data: JSON.stringify([payload]),
                    });
                    if (res && res.status > 0) return;
                    this.$notice({ title: '成功', message: '新增分类成功', type: 'success' });
                } else {
                    const res = await INTERFACE_MODEL_TUTARIAL.EDIT_TUTARIAL_CATE({
                        data: JSON.stringify([{ id: this.form.id, ...payload }]),
                    });
                    if (res && res.status > 0) return;
                    this.$notice({ title: '成功', message: '编辑分类成功', type: 'success' });
                }
                this.dialogVisible = false;
                await this.loadCateList();
                this.refreshCateCache();
                this.$emit('categories-updated', {});
            } catch (e) {
                this.$notice({ title: '错误', message: '提交失败', type: 'error' });
            } finally {
                this.submitLoading = false;
            }
        },
        handleDeleteCate(item) {
            if (!item || !item.id) return;
            const cateName = item.name && String(item.name).trim() ? String(item.name).trim() : '该分类';
            this.$confirm
                .confirm(
                    `确定删除「${cateName}」吗？删除后不可恢复，相关教程分类需自行调整。`,
                    '删除提示',
                    { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' },
                )
                .then(async () => {
                    try {
                        const res = await INTERFACE_MODEL_TUTARIAL.DEL_TUTARIAL_CATE({ ids: item.id });
                        if (res && res.status > 0) return;
                        this.$notice({ title: '成功', message: '删除分类成功', type: 'success' });
                        const sel = String(this.selectedId || '');
                        const needClear = sel && String(item.id) === sel;
                        await this.loadCateList();
                        this.refreshCateCache();
                        this.$emit('categories-updated', { clearSelection: needClear });
                    } catch (e) {
                        this.$notice({ title: '错误', message: '删除失败', type: 'error' });
                    }
                })
                .catch(() => {});
        },
    },
};
</script>

<style scoped>
.TTL-cate-box {
    display: inline-block;
    width: 250px;
    height: calc(100% - 2px);
    border: 1px solid #bbb9b9;
    border-radius: 10px;
}
.TTL-add-cate {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 50px;
    font-size: 13px;
    color: #333;
    border-bottom: 1px solid #bbb9b9;
    cursor: pointer;
}
.TTL-cate-content {
    display: inline-block;
    padding: 0 10px;
    width: calc(100% - 20px);
    height: calc(100% - 50px);
    overflow-y: auto;
}
.TTL-cate-content::-webkit-scrollbar {
    width: 0;
}
.cate-box {
    display: inline-block;
    padding: 0 0 0 10px;
    width: calc(100% - 10px);
    font-size: 0;
}
.cate-item {
    position: relative;
    display: inline-block;
    width: 100%;
    font-size: 0;
}
.cate-name-box {
    display: inline-flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0;
    width: 100%;
    font-size: 13px;
    color: #333;
}
.cate-name-box .title {
    display: inline-flex;
    align-items: center;
    flex: 1;
    min-width: 0;
    box-sizing: border-box;
    padding-right: 10px;
    cursor: pointer;
}
.cate-name-box .title.title-with-caret {
    gap: 6px;
}
.cate-name-box .title .cate-title-text {
    flex: 1;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.cate-name-box .cate-title-caret {
    flex-shrink: 0;
    display: inline-block;
    width: 0;
    height: 0;
    margin-right: 2px;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 5px solid #999;
    border-bottom: 0;
    vertical-align: middle;
}
.cate-name-box .icon-box {
    display: inline-flex;
    gap: 10px;
}
.cate-name-box .icon-box .icon {
    width: 15px;
    height: 15px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100%;
    cursor: pointer;
}
.cate-name-box .icon-box .del {
    background-image: url('@/assets/icon/del-black.png');
}
.cate-name-box .icon-box .edit {
    background-image: url('@/assets/icon/edit-black.png');
}
.add-tutarial-cate-form {
    display: block;
    width: 100%;
}
.add-tutarial-cate-form .form-item {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
}
.add-tutarial-cate-form .form-item:last-child {
    margin-bottom: 0;
}
.add-tutarial-cate-form .form-label {
    flex-shrink: 0;
    width: 72px;
    margin-right: 10px;
    font-size: 13px;
    color: #333;
}
.add-tutarial-cate-form .form-control {
    flex: 1;
}
.dialog-footer {
    display: inline-flex;
    justify-content: flex-end;
    column-gap: 10px;
    width: 100%;
}
</style>
